module.exports = __webpack_public_path__ + "static/img/my_card2.0cf1338.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/my_card2.jpg
// module id = bIyN
// module chunks = 0